import { render, staticRenderFns } from "./coalTunnelBtn.vue?vue&type=template&id=317f110f&scoped=true&"
import script from "./coalTunnelBtn.vue?vue&type=script&lang=js&"
export * from "./coalTunnelBtn.vue?vue&type=script&lang=js&"
import style0 from "./coalTunnelBtn.vue?vue&type=style&index=0&id=317f110f&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "317f110f",
  null
  
)

export default component.exports